import React, { useState } from 'react';

const Header = ({ user, currentPage, onNavigate, onLogout, pendingCount, registrationEnabled, isProcessingPayment }) => {
  const isAdmin = user?.role === 'admin';
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLinkClick = (page) => {
    onNavigate(page);
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container header-container-left">
        <div 
          className="logo-section" 
          onClick={() => {
            if (!user) {
              handleLinkClick('home');
            }
          }} 
          style={{ cursor: user ? 'default' : 'pointer' }}
        >
          <img src="/ttab-logo.png" alt="TTAB Logo" className="logo-img" />
        </div>

        <nav className={`nav-menu ${menuOpen ? 'mobile-active' : ''}`}>
          {isProcessingPayment ? null : user ? (
            <div className="nav-links-wrapper">
              <div className="nav-links-container">
                {isAdmin ? (
                  <>
                    <span className="nav-link-header" onClick={() => handleLinkClick('dashboard')}>DASHBOARD</span>
                    <span className="nav-link-header" onClick={() => handleLinkClick('fees')}>FEES</span>
                    <span className="nav-link-header" onClick={() => handleLinkClick('requests')}>
                      REQUESTS 
                    </span>
                    <span className="nav-link-header" onClick={() => handleLinkClick('players')}>PLAYERS</span>
                    <span className="nav-link-header" onClick={() => handleLinkClick('report')}>REPORT</span>
                  </>
                ) : (
                  <>
                    <span className="nav-link-header" onClick={() => handleLinkClick('dashboard')}>DASHBOARD</span>
                    <span className="nav-link-header" onClick={() => handleLinkClick('history')}>HISTORY</span>
                  </>
                )}
              </div>
              <button className="btn-logout-box" onClick={() => { onLogout(); setMenuOpen(false); }}>LOGOUT</button>
            </div>
          ) : (
            <div className="nav-links-wrapper mobile-only">
              <div className="nav-links-container">
                <span className="nav-link-header" onClick={() => handleLinkClick('login')}>LOGIN</span>
                {registrationEnabled && (
                  <span className="nav-link-header" style={{ color: 'var(--color-primary)' }} onClick={() => handleLinkClick('register')}>REGISTER</span>
                )}
              </div>
            </div>
          )}
        </nav>

        <div className="header-controls">
          {!user && (
            <div className="header-auth-group desktop-only">
              <button className="btn-header-login" onClick={() => handleLinkClick('login')}>LOGIN</button>
              {registrationEnabled && (
                <button className="btn-header-register" onClick={() => handleLinkClick('register')}>REGISTER</button>
              )}
            </div>
          )}
          
          {!isProcessingPayment && (
            <div className={`mobile-menu-icon ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;